export default "__VITE_ASSET__BSau$H7Q__"